import { LoginForm } from '@/features/login';

export const LoginPage = () => {
  return <LoginForm />;
};
